module.exports = __webpack_public_path__ + "img/6.1ec959e3.jpg";